/**
 * Capitan header v1.0.0
 *
 * Copyright brandung GmbH & Co.KG
 * http://www.Capitan.de/
 *
 * Date: 2017-01-14
 * MIT License (MIT)
 */
import CapSmartResize from '../../code/js/Capitan/es6/CapSmartResize';
import Capitan from '../../code/js/Capitan/Capitan';
var _ = {
  defaults: {
    componentSelector: 'header',
    pluginOptions: {
      selectors: {
        headerMain: '.header__main-wrapper'
      },
      classes: {
        sticky: 'is-header-sticky',
        fixed: 'is-fixed'
      }
    }
  }
};
var o = _.defaults;
export function init() {
  var component = document.querySelector(o.componentSelector);

  if (component) {
    var headerHeight = component.offsetHeight;
    component.classList.add(o.pluginOptions.classes.fixed);
    document.body.style.paddingTop = headerHeight + 'px';
    Capitan.assertBreakpoint('ht', 'sm') && window.addEventListener('scroll', function () {
      if (window.scrollY > headerHeight && !document.body.classList.contains(o.pluginOptions.classes.sticky)) {
        document.body.classList.add(o.pluginOptions.classes.sticky);
      } else if (window.scrollY === 0) {
        document.body.classList.remove(o.pluginOptions.classes.sticky);
      }
    }); // Works on desktop browsers only

    if (navigator.userAgent.match(/Trident\//) || navigator.userAgent.match(/Edge\//)) {
      document.body.addEventListener('mousewheel', function (evt) {
        evt.preventDefault();
        var wd = evt.wheelDelta;
        var csp = window.pageYOffset;
        window.scrollTo(0, csp - wd);
      }); // If the code block above doesn't work, please try attaching the event to the window like so:
      //     window.addEventListener("mousewheel", function(evt) {
      //         evt.preventDefault();
      //         var wd = evt.wheelDelta;
      //         var csp = window.pageYOffset;
      //         window.scrollTo(0, csp - wd);
      //     });
    }

    CapSmartResize(function () {
      headerHeight = component.offsetHeight;
      document.body.style.paddingTop = headerHeight + 'px';
      Capitan.assertBreakpoint('ht', 'sm') && window.addEventListener('scroll', function () {
        if (window.scrollY > headerHeight && !document.body.classList.contains(o.pluginOptions.classes.sticky)) {
          document.body.classList.add(o.pluginOptions.classes.sticky);
          var menuIsActive = document.querySelector('.has-tab.is-active');

          if (menuIsActive) {
            document.querySelector('.has-tab.is-active').classList.remove('is-active');
            document.body.classList.remove('nav-flyout-open');
          }
        } else if (window.scrollY === 0) {
          document.body.classList.remove(o.pluginOptions.classes.sticky);
        }
      });
    });
  }
}